import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import Lazy from 'lazy.js';

import MobileHeader from '../../components/MobileHeader/MobileHeader';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';

import FormSection from '../../components/FormSection/FormSection';
import FormGroup from '../../components/FormGroup/FormGroup';
import BookDropdown from '../../components/BookDropdown/BookDropdown';

import Input from 'react-bootstrap/lib/Input';

const ProfileBook = React.createClass({

	mixins: [LinkedStateMixin, ReactFireMixin],

	getInitialState() {
		return {
			text: ''
		}
	},

	contextTypes: {
		history: React.PropTypes.object.isRequired,
		userRef: React.PropTypes.object
	},

	componentWillMount() {
		this.booksRef = firebaseRoot.child('content/books');
		this.bindAsArray(this.booksRef, 'books');
	},

	render(){
		const filteredBooks = this.state.books.filter(book => {
			return book['.key'].startsWith(this.state.text);
		});

		return (
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='signupSteps'
					title='Book'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content bg-gray">
					<BookDropdown filteredBooks={filteredBooks} visible={this.state.text} handleClickBook={this.handleClickBook}>
						<FormSection>
							<FormGroup
								label="ISBN"
							>
								<Input type="number" valueLink={this.userLinkState("text")}/>
							</FormGroup>
						</FormSection>
					</BookDropdown>
					<div className="profile-content">
						<p className="text-center" style={{fontSize: '110px', lineHeight: '1em'}}><Glyphicon
							glyph="barcode"/></p>
						<p>The International standard book number (<abbr
							title="International standard book number">ISBN</abbr>) is a unique identifier for
							commercial books. You can usally find this code in the back of your textbook.</p>
					</div>
				</div>
			</div>
		);
	},

	userLinkState(name) {
		return {
			value: this.state[name],
			requestChange: (newValue) => {
				this.setState({[name]: newValue});
			}
		}
	},

	handleClickBook(clickedBookKey) {
		this.setState({text: clickedBookKey});
		this.saveBook(clickedBookKey);
	},

	saveBook(clickedBookKey) {
		this.context.userRef.ref().child('isbn').set(clickedBookKey).then(
			() => this.context.history.goBack(),
			error => window.alert(error)
		);
	}

});

export default ProfileBook;


/** WEBPACK FOOTER **
 ** ./src/screens/signup/SignupBook.js
 **/